import { loadStripe } from '@stripe/stripe-js'

export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

const stripePromiseCache = new Map()

export const getStripePromise = (connectedAccountId) => {
  const cacheKey = connectedAccountId || 'platform'

  if (!stripePromiseCache.has(cacheKey)) {
    stripePromiseCache.set(
      cacheKey,
      loadStripe(
        process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
        connectedAccountId
          ? { stripeAccount: connectedAccountId }
          : undefined
      )
    )
  }

  return stripePromiseCache.get(cacheKey)
}
